import React from "react";
import { View } from "./View";
export var route = {
    match: function (type) {
        return type === "TicketOverview";
    },
    page: function (_a) {
        var data = _a.data;
        return React.createElement(View, { data: data });
    },
    showNav: function () { return true; },
    hideFooter: function () { return false; },
};
